export enum RoutesPaths {
    PurchasingList = '/purchasing',
    PurchasingNew = '/purchasing/new',
    PurchasingDetail = '/purchasing/:id',
    PurchasingSuppliers = '/purchasing/suppliers',
    PurchasingReports = '/purchasing/reports',
}
